import { useMutation } from '@tanstack/react-query';
import type { JobChangeProcessBoardPatchRequest } from '../types/JobChangeProcessBoard';
import parseBoardResponse from './parseBoardResponse';

export default function useUpdateJobChangeProcessBoard() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      id,
      title,
      divide_status,
      order_number,
      color_type,
    }: JobChangeProcessBoardPatchRequest) => {
      const response = await fetch(`/agent/api/job_change_process_boards/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          title,
          divide_status,
          order_number,
          color_type,
        }),
      });
      return parseBoardResponse(response, 'ボードの更新に失敗しました');
    },
  });
}
